  import { Component, OnInit,ViewChild } from '@angular/core';
  import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
  import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
  import { LoginService } from '../../Shared/Service/login_service';
  import { DashboarduiService } from '../../Shared/Service/dashboardui.service';
  import { DatePipe } from '@angular/common';
  import { ToastrService } from 'ngx-toastr';
  import { IDropdownSettings } from 'ng-multiselect-dropdown';
  import beautify from 'xml-beautifier';
  import { Router } from '@angular/router';
  export const MY_FORMATS = {
    parse: {
      dateInput: 'LL',
    },
    display: {
      dateInput: 'LL',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
    },
  };
  export class idsProductList {
    id: number;
    status: String;
    hotelName: String;
    accountingDate: Date;
    pusheddate: any;
    type: any
  }
@Component({
  selector: 'app-fom-from-crmdb-new',
  templateUrl: './fom-from-crmdb-new.component.html',
  styleUrls: ['./fom-from-crmdb-new.component.css'],
      providers: [LoginService,
          {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
          },
      
          { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        ]
})

  
export class FomFromCrmdbNewComponent implements OnInit {

 display: boolean;
      constructor(private apiCallIdsService: DashboarduiService,public router:Router, private toastr: ToastrService, 
          private datePipe: DatePipe,) { }
    searchBarFilter: boolean = false;
      today = new Date();
      today1 = new Date();
      Val: string;
      dataLoaded = false;
      isProgressing: Boolean = false;
        Pmscodevalue: any;
      errorMsgSubscription: boolean;
      errorMessage: string;
      displayContent: boolean;
      selectedDateStore: any;
      selectedTOODateStore: any;
      selectedDate: any = new Date(this.today.setDate(this.today.getDate()));
      selectedTOODate: any = new Date(this.today1.setDate(this.today1.getDate()));
      statusResult: string;
      requestPayload: any;
      idsProductList: idsProductList[] = [];
      dataSource: MatTableDataSource<idsProductList>;
      dropdownSettingsDept: IDropdownSettings = {};
      dropdownDeptData: any
      totalcount: any = 0;
      filterProperty: any;
      @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
      @ViewChild(MatSort, { static: false }) sort: MatSort;
      Userid: any = [];
      apiresult: any;
      selectedDeptItems: any;
    CurrentDate = new Date();
      checkTodayDate:any
      XMLName: any;
      defaultData: any;
      search: string;
      pageSize = 50;
        status: void;
          summaryData: any[] = [];
      detailedData: any[] = [];
      filteredDetailList: any[] = [];
      selectedSummaryFilter: 'Total' | 'Success' | 'Fail' = 'Total';
      displayedColumns: string[] = ['pmscode','hotelname', 'total', 'success', 'fail'];
      showingSummary: boolean = true;
      hideSearchFilter(){
        this.Val = '';
        this.searchBarFilter = false
      }

  ngOnInit() {this.checkTodayDate = this.CurrentDate.getDate()
      console.log('check Today =', this.checkTodayDate)
      this.isProgressing = true;
      this.Userid = localStorage.getItem("Username");
      console.log(this.Userid)
      this.errorMsgSubscription = true
      this.statusResult = "not sent"
      this.errorMessage = "Please select property and load"
      this.displayContent = false
      const restoredState = history.state;

      const state = history.state;

  if (state && state.summaryData) {
    this.summaryData = state.summaryData;
    this.detailedData = state.detailedData || [];
    this.selectedDateStore = state.fromDate;
    this.selectedTOODateStore = state.toDate;
    this.Pmscodevalue = state.Pmscodevalue;
    this.selectedDeptItems = state.selectedDeptItems;

    this.callIDSUsersProperties();

    this.displayContent = true;
    this.dataSource = new MatTableDataSource(this.summaryData);
    this.totalcount = this.summaryData.length;
    this.errorMsgSubscription = false;
    this.isProgressing = false;
  } else {
    //this.GetLoadMethodIDSUser();
    this.callIDSUsersProperties();
  }

  //this.callIDSUsersProperties(); 
      this.dropdownSettingsDept = {
        idField: 'propertyCode',
        textField: 'propertyName',
        allowSearchFilter: true,
        singleSelection: true,
        enableCheckAll: false,
        closeDropDownOnSelection: true,
        itemsShowLimit: 7,
       // noDataAvailablePlaceholderText: 'No Data Found',
        searchPlaceholderText: "Search Hotel Code / Name"
      };
    }
callIDSUsersProperties() {
      this.Userid = localStorage.getItem("Username");
      console.log(this.Userid)
      this.apiCallIdsService.getITCCRMFOMPropList()
        .subscribe(
          data => {
            console.log('New Screen Data', data)
            //Remove duplicate data
            this.apiresult = data;
            this.apiresult.unshift({
              "propertyCode": "All",
              "propertyName": "All Property"
            });

            this.dropdownDeptData = this.apiresult
            // if (this.SourceBy == 'Report') {
            this.selectedDeptItems = this.getDimensionsByFilter("All");
            console.log('this.StoreValuetest', this.selectedDeptItems[0].propertyCode);
            this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
            console.log('this.Pmscodevalue =', this.Pmscodevalue)
            // }
            console.log('Property 113 = ', data)
            this.isProgressing = false;
          });
    } changePropertySearch() {
      // console.log('selectedDeptItems = ',this.selectedDeptItems)
      if (this.selectedDeptItems) {
        this.searchBarFilter = false
      this.Val = '';
        if (this.selectedDeptItems.length > 0) {
          console.log('if condition')
          this.totalcount = 0;
          console.log('selectedDeptItems = ', this.selectedDeptItems)
          this.errorMsgSubscription = true
          this.errorMessage = "Please select property and load"
          this.displayContent = false
          this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
          console.log('pms code value = ', this.Pmscodevalue)

        } else {
          console.log('Else condition zero')
          this.errorMsgSubscription = true
          this.errorMessage = "Please select property and load"
          this.displayContent = false
        }
      } else {
        console.log('Property Not Selected')
      }
    }
    allIDSUsersProperties() {
      this.Userid = localStorage.getItem("Username");
      console.log(this.Userid)
      this.apiCallIdsService.getITCCRMFOMPropList()
        .subscribe(
          data => {
            console.log('New Screen Data', data)
            //Remove duplicate data
            this.apiresult = data;
            this.apiresult.unshift({
              "propertyCode": "All",
              "propertyName": "All Property"
            });

            this.dropdownDeptData = this.apiresult
            // if (this.SourceBy == 'Report') {
            this.selectedDeptItems = this.getDimensionsByFilter("All");
            console.log('this.StoreValuetest', this.selectedDeptItems[0].propertyCode);
            this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
            console.log('this.Pmscodevalue =', this.Pmscodevalue)
            // }
            console.log('Property 113 = ', data)
            this.isProgressing = false;
          });
    }
  GetLoadMethodIDSUser() {
    this.isProgressing = true;
    this.selectedDateStore = this.datePipe.transform(this.selectedDate, 'yyyyMMdd');
    this.selectedTOODateStore = this.datePipe.transform(this.selectedTOODate, 'yyyyMMdd');

    const payload = {
      PMSCODE: this.Pmscodevalue === 'All' ? '' : this.Pmscodevalue,
      FRMDATE: this.selectedDateStore,
      TOODATE: this.selectedTOODateStore
    };

    this.apiCallIdsService.readITCCRMFOMAPINew(payload).subscribe((data) => {
      this.isProgressing = false;

      if (data && data.count && data.count.length > 0) {
    this.summaryData = data.count;
    this.detailedData = data.list ? data.list : [];

    this.showingSummary = true;
    this.displayedColumns = ['pmscode', 'hotelname', 'total', 'success', 'fail'];
    this.dataSource = new MatTableDataSource(this.summaryData);
    this.dataSource.paginator = this.paginator;

    this.totalcount = this.summaryData.length;
    this.displayContent = true;
    this.errorMsgSubscription = false;
  } else {
    this.toastr.error('No Data Found');
    this.displayContent = false;
    this.errorMsgSubscription = true;
    this.errorMessage = 'No Data Found';
  }
    });
  }
applySummaryFilter(status: string, element: any) {
  this.router.navigate(['/ITCCRMFOMLog/fom-from-crmdb-new-list'], {
    queryParams: {
      pmscode: element.pmscode,
      status: status,
      fromDate: this.selectedDateStore,
      toDate: this.selectedTOODateStore,
      hotelname: element.hotelname
    },
    state: {
      summaryData: this.summaryData,
      detailedData: this.detailedData,
      selectedDateStore: this.selectedDateStore,
      selectedTOODateStore: this.selectedTOODateStore,
      Pmscodevalue: this.Pmscodevalue,
      selectedDeptItems: this.selectedDeptItems
    }
  });
}
pageEvent(e: any) {
        console.log('pageEvent = ', e)
        var pageIndex = e.pageIndex;
        pageIndex = pageIndex;
        console.log('pageIndex = ', pageIndex)
        this.pageSize = e.pageSize
        console.log('pageSize = ', this.pageSize)
        this.GetLoadMethodIDSUser();
      }
      getDimensionsByFilter(propertyCode: any) {
      console.log('dropdownDeptData =', this.dropdownDeptData)
      return this.dropdownDeptData.filter((x: { propertyCode: any; }) => x.propertyCode === propertyCode);
    }
}
